import type { FC, PropsWithChildren } from "react";

import type { UpgradeCellContainerProps } from "app/components/table/components/UpgradeCellContainer";
import { UpgradeCellContainer } from "app/components/table/components/UpgradeCellContainer";
import { getPackagesPageHref } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";

export const SiUpgradeCellContainer: FC<PropsWithChildren<UpgradeCellContainerProps>> = ({
    children,
    ...otherProps
}) => (
    <UpgradeCellContainer
        {...otherProps}
        requestOptions={{
            isRedirectToNT: false,
            packageUrl: getPackagesPageHref(),
        }}
    >
        {children}
    </UpgradeCellContainer>
);
